module.exports = __webpack_public_path__ + "static/media/postman.4dab9f25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/postman.png
// module id = 170
// module chunks = 0